import _regeneratorRuntime from "/var/jenkins_home/workspace/online-k8s-web-product-cloudv2@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/online-k8s-web-product-cloudv2@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-138a30d7"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  key: 0,
  class: "info"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-zhuyi"
  }, null, -1);
});
var _hoisted_3 = {
  class: "footer-btn"
};
var __default__ = {
  name: 'BindProduct'
};
import Model from '@/api/model';
import Product from '@/api/product';
import { $formErr, $getPhoneArea, $rdoLang } from '@/assets/common/common';
import { useMatomo } from '@shining3d/matomo';
import { XlAreaCode, XlButton, XlDialog, XlInput, XlMessage, XlSelect } from '@shining3d/ui-components';
import { VueCookieNext } from 'vue-cookie-next';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useLang } from '../../hooks/lang';
export default /*#__PURE__*/Object.assign(__default__, {
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup: function setup(__props, _ref) {
    var emits = _ref.emit;
    var props = __props;
    var matomo = useMatomo();
    var _useLang = useLang(),
      $t = _useLang.$t;
    var store = useStore();
    var router = useRouter();
    var dialogVisible = computed({
      get: function get() {
        return props.modelValue;
      },
      set: function set(val) {
        emits('update:modelValue', val);
      }
    });
    var formData = reactive({
      sn: ''
    });
    var formRef = ref();
    var formRules = {
      sn: [{
        required: true,
        message: $t('bind.form.sn'),
        trigger: 'blur'
      }]
    };
    var formErr = reactive({});
    var productList = ref([]);
    var getAllModelList = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$Model$getAllMo, result, status;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Model.getAllModelList({
                lang: $rdoLang(VueCookieNext.getCookie('lang'))
              });
            case 2:
              _yield$Model$getAllMo = _context.sent;
              result = _yield$Model$getAllMo.result;
              status = _yield$Model$getAllMo.status;
              if (status === 'success') {
                result.forEach(function (item) {
                  item.value = item.code;
                  item.label = item.name;
                });
                productList.value = result;
              } else {
                productList.value = [];
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getAllModelList() {
        return _ref2.apply(this, arguments);
      };
    }();
    var showInfo = ref(false);
    var handleInput = function handleInput() {
      showInfo.value = false;
      formErr.sn = '';
    };
    var bindLoading = ref(false);
    var bindSN = function bindSN() {
      formRef.value.validate(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(valid) {
          var _yield$Product$bind, status, result;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                if (!valid) {
                  _context2.next = 10;
                  break;
                }
                bindLoading.value = true;
                _context2.next = 4;
                return Product.bind(formData);
              case 4:
                _yield$Product$bind = _context2.sent;
                status = _yield$Product$bind.status;
                result = _yield$Product$bind.result;
                if (status === 'success') {
                  closeDialog();
                  router.push({
                    path: '/product'
                  });
                  XlMessage({
                    type: 'success',
                    message: $t('bind.bindSuccess')
                  });
                } else {
                  showInfo.value = true;
                  $formErr(result, formErr);
                }
                bindLoading.value = false;
                matomo.log('click', '首页|绑定更多产品|绑定', '绑定更多产品');
              case 10:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }());
    };
    var feedBackFormData = reactive({
      phoneArea: $getPhoneArea(),
      codeActuralSelect: '',
      username: '',
      comments: '',
      modelCode: ''
    });
    var feedBackLoading = ref(false);
    var validUserName = function validUserName(rule, value, callback) {
      var emailReg = new RegExp('^[a-z0-9]+([._\\\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$');
      var phoneReg = /[0-9]+/g;
      // 校验正则满足任何一个即可
      if (emailReg.test(value) || phoneReg.test(value) && value.indexOf('@') === -1) {
        callback();
      } else {
        callback(new Error($t('rules.vAccountFormat')));
      }
    };
    var feedBackFormRules = {
      modelCode: [{
        required: true,
        message: $t('bind.form.modelCode'),
        trigger: 'blur'
      }],
      username: [{
        required: true,
        message: $t('rules.notEmpty'),
        trigger: 'blur'
      }, {
        validator: validUserName,
        trigger: 'blur'
      }],
      comments: [{
        required: true,
        message: $t('rules.notEmpty'),
        trigger: 'blur'
      }]
    };
    var feedBackFormRef = ref(null);
    var feedback = function feedback() {
      formRef.value.validate(function (valid) {
        if (valid) {
          console.log(valid);
          feedBackFormRef.value.validate(/*#__PURE__*/function () {
            var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_valid) {
              var params, _yield$Model$feedback, status;
              return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    if (!_valid) {
                      _context3.next = 9;
                      break;
                    }
                    feedBackLoading.value = true;
                    params = {
                      countryCode: VueCookieNext.getCookie('country'),
                      phoneArea: feedBackFormData.phoneArea,
                      username: feedBackFormData.username,
                      modelCode: feedBackFormData.modelCode,
                      comments: feedBackFormData.comments,
                      sn: formData.sn
                    };
                    _context3.next = 5;
                    return Model.feedback(params);
                  case 5:
                    _yield$Model$feedback = _context3.sent;
                    status = _yield$Model$feedback.status;
                    if (status === 'success') {
                      XlMessage({
                        type: 'success',
                        message: $t('bind.feedbackMessage')
                      });
                      closeDialog();
                      matomo.log('click', '首页|绑定更多产品|提交反馈', '绑定更多产品提交反馈');
                    }
                    feedBackLoading.value = false;
                  case 9:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            }));
            return function (_x2) {
              return _ref4.apply(this, arguments);
            };
          }());
        }
      });
    };
    var cancel = function cancel() {
      closeDialog();
      matomo.log('click', '首页|绑定更多产品|取消', '拒绝绑定更多产品');
    };
    var closeDialog = function closeDialog() {
      for (var key in formErr) {
        formErr[key] = '';
      }
      formData.sn = '';
      feedBackFormData.modelCode = '';
      feedBackFormData.phoneArea = $getPhoneArea();
      feedBackFormData.username = '';
      feedBackFormData.comments = '';
      showInfo.value = false;
      dialogVisible.value = false;
      bindLoading.value = false;
      feedBackLoading.value = false;
    };
    onMounted(function () {
      getAllModelList();
      // feedBackFormData.phoneArea = getPhoneAreaByCountry();
    });
    return function (_ctx, _cache) {
      var _component_el_col = _resolveComponent("el-col");
      var _component_el_row = _resolveComponent("el-row");
      var _component_el_form_item = _resolveComponent("el-form-item");
      var _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createBlock(_unref(XlDialog), {
        "destroy-on-close": "",
        width: "430px",
        "close-on-click-modal": false,
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
          return _isRef(dialogVisible) ? dialogVisible.value = $event : null;
        }),
        onClose: cancel,
        title: _unref($t)('home.binding'),
        "custom-class": "dialogView"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_form, {
            "label-position": "top",
            model: _unref(formData),
            ref_key: "formRef",
            ref: formRef,
            rules: formRules
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_form_item, {
                class: _normalizeClass(showInfo.value ? '' : 'mb86'),
                label: _unref($t)('bind.productSN'),
                error: _unref(formErr).sn,
                prop: "sn"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_row, {
                    class: "w100"
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_col, {
                        span: 18,
                        style: {
                          "padding-right": "8px"
                        }
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_unref(XlInput), {
                            modelValue: _unref(formData).sn,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                              return _unref(formData).sn = $event;
                            }),
                            onInput: handleInput
                          }, null, 8, ["modelValue"])];
                        }),
                        _: 1
                      }), _createVNode(_component_el_col, {
                        span: 6
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_unref(XlButton), {
                            type: "primary",
                            class: "w100",
                            loading: bindLoading.value,
                            onClick: bindSN
                          }, {
                            default: _withCtx(function () {
                              return [_createTextVNode(_toDisplayString(_unref($t)("bind.bind")), 1)];
                            }),
                            _: 1
                          }, 8, ["loading"])];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              }, 8, ["class", "label", "error"])];
            }),
            _: 1
          }, 8, ["model"]), showInfo.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", null, [_hoisted_2, _createTextVNode(_toDisplayString(_unref($t)("bind.info")), 1)])])) : _createCommentVNode("", true), showInfo.value ? (_openBlock(), _createBlock(_component_el_form, {
            key: 1,
            ref_key: "feedBackFormRef",
            ref: feedBackFormRef,
            "label-position": "top",
            model: _unref(feedBackFormData),
            rules: feedBackFormRules
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_form_item, {
                label: _unref($t)('bind.productModel'),
                prop: "modelCode",
                style: {
                  "margin-top": "8px"
                }
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_row, {
                    class: "w100"
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_unref(XlSelect), {
                        modelValue: _unref(feedBackFormData).modelCode,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                          return _unref(feedBackFormData).modelCode = $event;
                        }),
                        class: "w100",
                        placeholder: _unref($t)('bind.placeholder'),
                        options: productList.value,
                        filterable: ""
                      }, null, 8, ["modelValue", "placeholder", "options"])];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              }, 8, ["label"]), _createVNode(_component_el_form_item, {
                label: _unref($t)('bind.contact'),
                prop: "username"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_unref(XlAreaCode), {
                    selectValue: _unref(feedBackFormData).phoneArea,
                    "onUpdate:selectValue": _cache[2] || (_cache[2] = function ($event) {
                      return _unref(feedBackFormData).phoneArea = $event;
                    }),
                    acturalSelect: _unref(feedBackFormData).codeActuralSelect,
                    "onUpdate:acturalSelect": _cache[3] || (_cache[3] = function ($event) {
                      return _unref(feedBackFormData).codeActuralSelect = $event;
                    }),
                    inputValue: _unref(feedBackFormData).username,
                    "onUpdate:inputValue": _cache[4] || (_cache[4] = function ($event) {
                      return _unref(feedBackFormData).username = $event;
                    }),
                    areaCode: _unref(store).state.phoneAreaList,
                    isValueTrim: "",
                    placeholder: _unref($t)('bind.input')
                  }, null, 8, ["selectValue", "acturalSelect", "inputValue", "areaCode", "placeholder"])];
                }),
                _: 1
              }, 8, ["label"]), _createVNode(_component_el_form_item, {
                class: "mt24",
                label: _unref($t)('bind.problem'),
                prop: "comments"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_unref(XlInput), {
                    modelValue: _unref(feedBackFormData).comments,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
                      return _unref(feedBackFormData).comments = $event;
                    }),
                    type: "textarea",
                    autosize: {
                      minRows: 5
                    },
                    maxlength: "200",
                    "show-word-limit": ""
                  }, null, 8, ["modelValue"])];
                }),
                _: 1
              }, 8, ["label"]), _createVNode(_component_el_form_item, {
                style: {
                  "margin-bottom": "2px"
                }
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_3, [_createVNode(_unref(XlButton), {
                    style: {
                      "width": "100%"
                    },
                    onClick: cancel
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode(_toDisplayString(_unref($t)("button.cancel")), 1)];
                    }),
                    _: 1
                  }), _createVNode(_unref(XlButton), {
                    type: "primary",
                    onClick: feedback,
                    loading: feedBackLoading.value,
                    style: {
                      "width": "100%"
                    }
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode(_toDisplayString(_unref($t)("bind.feedback")), 1)];
                    }),
                    _: 1
                  }, 8, ["loading"])])];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["model"])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }
});